export class DadosFiltroModel {
    public silo?: { id: number };
    public dataInicio: string;
    public dataFim: string;
}
